export default __webpack_public_path__ + "static/media/package_5.99c49619.png";